import { useMemo } from "react";

import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `ManageIgnoredValuesRoot`,
  header: `ManageIgnoredValuesHeader`,
  headerText: `ManageIgnoredValuesHeaderText`,
  headerClose: `ManageIgnoredValuesHeaderClose`
};

export function useManageIgnoredSourceDataStyles() {
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          height: `100%`,
          overflowY: `scroll`,
          overfolow: `hidden`,
          width: `100%`,
          marginTop: `25px`
        }
      ],
      header: [
        classNames.header,
        {
          width: `100%`,
          height: `32px`
        }
      ],
      headerText: [
        classNames.headerText,
        {
          paddingLeft: `23px`
        }
      ],
      headerClose: [
        classNames.headerClose,
        {
          "& .ms-Panel-closeButton": {
            height: `32px`,
            selectors: {
              ":hover": {
                background: `transparent`
              }
            }
          }
        }
      ]
    }),
    []
  );
}
